import GetBrandFromManufacturer from "./GetBrandFromManufacturer";
import getManufacturerFromBrand from "./GetManufacturerFromBrand";

export default function(route) {
    const routeName = route.name || 'used-landing';

    // Since the used-results route now uses a dynamic route parameter for each type of search (e.g. delivery mileage or special offers or normal search)
    // This block of if statements controls the meta data for each of those types of search result pages
    if (routeName == 'used-results') {
        const resultsType = route.params.resultsType || 'used-vehicles';

        if (resultsType == 'nearly-new') {
            return {
                bodyClasses: [
                    'used',
                    'search',
                ],
                nearlyNew: 1,
                searchPage: true,
                title: 'Nearly New Cars for Sale UK | Second Hand Car Sales | Approved Used Car Supermarket',
                skipMediahawk: true,
                desc: 'Browse our extensive range of used cars today online at Stellantis &You. Find out more about our catalogue of approved used cars now.',
                customerType: 'Used',
            };
        }

        if (resultsType == 'used-special-offers') {
            return {
                bodyClasses: [
                    'used',
                    'search',
                ],
                searchPage: true,
                specialOffer: 1,
                title: 'Used Special Offers for Sale UK | Second Hand Car Sales | Approved Used Car Supermarket',
                skipMediahawk: true,
                desc: 'Find approved used special offers near you with Stellantis &You UK - Get great deals on second hand cars, book a test drive & discuss our amazing finance deals',
                customerType: 'Used',
            };
        }

        if (resultsType == 'delivery-mileage') {
            return {
                bodyClasses: [
                    'used',
                    'search',
                ],
                searchPage: true,
                preReg: 1,
                title: 'Delivery Mileage vehicles for Sale UK | Second Hand Car Sales | Approved Used Car Supermarket',
                skipMediahawk: true,
                desc: 'Find approved delivery mileage cars near you with Stellantis &You UK - Get great deals on second hand cars, book a test drive & discuss our amazing finance deals',
                customerType: 'Used',
            };
        }

        return {
            bodyClasses: [
                'used',
                'search',
            ],
            searchPage: true,
            title: 'Stellantis &You UK | Used Vehicle Results',
            title: 'Used Cars for Sale UK | Second Hand Car Sales | Approved Used Car Supermarket',
            skipMediahawk: true,
            desc: 'Browse our extensive stock of used cars today online at Stellantis &You. Find out more about our wide array of approved used cars now.',
            customerType: 'Used',
        };
    }

    if (routeName == 'branded-used-results') {
        const brand = route.params.brand || 'randd';
        const manufacturer = getManufacturerFromBrand(brand);
        const resultsType = route.params.resultsType || 'used-vehicles';

        let newMetaData = {
            bodyClasses: [
                'used',
                'search',
            ],
            // Brand is randd because search results are not meant to use brand styling
            brand: 'randd',
            // Manufacturer meta param determins which manufacturer value this drop down should select
            manufacturer: manufacturer,
            searchPage: true,
            title: manufacturer +' Used Cars | Approved Used '+ manufacturer +' For Sale',
            skipMediahawk: true,
            desc: 'Find approved ' + manufacturer + ' used cars for sale near you in local Stellantis &You UK dealerships - book a test drive & discuss our amazing finance deals online',
            customerType: 'Used',
        };

        if (resultsType == 'nearly-new') {
            newMetaData.nearlyNew = 1;
            newMetaData.title = manufacturer +' Nearly New Cars | Approved Nearly New '+ manufacturer +' For Sale';
            newMetaData.desc = 'Find approved ' + manufacturer + ' nearly new cars for sale near you in local Stellantis &You UK dealerships - book a test drive & discuss our amazing finance deals online';
        }

        if (resultsType == 'used-special-offers') {
            newMetaData.specialOffer = 1;
            newMetaData.title = manufacturer +' Used Special Offers | Approved Used '+ manufacturer +' For Sale';
            newMetaData.desc = 'Find approved ' + manufacturer + ' used special offers for sale near you in local Stellantis &You UK dealerships - book a test drive & discuss our amazing finance deals online';
        }

        if (resultsType == 'delivery-mileage') {
            newMetaData.preReg = 1;
            newMetaData.title = manufacturer +' Delivery Mileage Cars | Approved Delivery Mileage '+ manufacturer +' For Sale';
            newMetaData.desc = 'Find approved ' + manufacturer + ' delivery mileage cars for sale near you in local Stellantis &You UK dealerships - book a test drive & discuss our amazing finance deals online';
        }

        return newMetaData;
    }

    if (routeName == 'branded-stock-search-results') {
        const brand = route.params.brand || 'randd';
        const manufacturer = getManufacturerFromBrand(brand);

        return {
            bodyClasses: [
                'used',
                'stock-search-results',
            ],
            // Brand is randd because search results are not meant to use brand styling
            brand: 'randd',
            // Manufacturer meta param determines which manufacturer value this drop down should select
            manufacturer: manufacturer,
            searchPage: true,
            title: 'New ' + manufacturer + ' Cars | New '+ manufacturer +' Stock For Sale',
            skipMediahawk: true,
            desc: 'Find new ' + manufacturer + ' cars for sale near you in local Stellantis &You UK dealerships - book a test drive & discuss our amazing finance deals online',
            newStockSearch: true,
            customerType: 'New',
        };
    }

    // CMS Model pages
    if (routeName == 'cms-landing-page') {
        const brand = route.params.brand || 'randd';
        const manufacturer = getManufacturerFromBrand(brand);
        const model = route.params.model || 'cars';

        return {
            bodyClasses: [
                'used',
                'search',
            ],
            searchPage: true,
            title: 'Used ' + manufacturer + ' ' + model + ' For Sale | Approved ' + manufacturer + ' ' + model + ' Used Cars Near You',
            skipMediahawk: true,
            alwaysVerifyRoute: true,
            desc: 'Find approved ' + manufacturer + ' ' + model + ' cars for sale near you in local Stellantis &You UK dealerships - book a test drive & discuss our amazing finance deals online',
            customerType: 'Used',
        };
    }

    if (routeName == 'branded-used-landing') {
        let brand = route.params.brand || 'randd';
        if (brand == 'citroen') {
            return {
                bodyClasses: [
                    'used',
                    'landing',
                    'bg-citroen',
                ],
                manufacturer: 'Citroen',
                brand: 'citroen',
                title: 'Approved Used Citroën Cars for Sale | 6 Month Warranty',
                skipMediahawk: true,
                desc: "Find a great deal on approved used Citroën cars with Stellantis &You UK, the nation's leading Citroën dealership. Book a test drive near you today.",
                customerType: 'Used',
            };
        }
        if (brand == 'vauxhall') {
            return {
                bodyClasses: [
                    'used',
                    'landing',
                    'bg-vauxhall',
                ],
                manufacturer: 'Vauxhall',
                brand: 'vauxhall',
                title: 'Approved Used Vauxhall Cars for Sale | 6 Month Warranty',
                skipMediahawk: true,
                desc: "Browse the collection of approved used Vauxhall cars from Stellantis &You UK - the nation's leading Vauxhall dealership. Explore now and book a test drive.",
                customerType: 'Used',
            };
        }
        if (brand == 'ds') {
            return {
                bodyClasses: [
                    'used',
                    'landing',
                    'bg-ds',
                ],
                manufacturer: 'DS Automobiles',
                brand: 'ds',
                title: 'Approved Used DS Cars for Sale | 6 Month Warranty',
                skipMediahawk: true,
                desc: "Find a great deal on approved used DS cars with Stellantis &You UK, the nation's leading DS dealership. Book a test drive near you today.",
                customerType: 'Used',
            };
        }
        if (brand == 'peugeot') {
            return {
                bodyClasses: [
                    'used',
                    'landing',
                    'bg-peugeot',
                ],
                manufacturer: 'Peugeot',
                brand: 'peugeot',
                title: 'Approved Used Peugeot Cars for Sale | 6 Month Warranty',
                skipMediahawk: true,
                desc: "Browse approved used Peugeot cars for sale near you. Our used cars come with a 6-month manufacturer's warranty, full inspection, and ownership history check.",
                customerType: 'Used',
            };
        }

        let manufacturer = getManufacturerFromBrand(brand);
        if (manufacturer == 'Stellantis &You UK' && usedManufacturer) {
            manufacturer = usedManufacturer;
            brand = GetBrandFromManufacturer(brand);
        }

        return {
            bodyClasses: [
                'used',
                'landing',
                'bg-' + brand,
            ],
            manufacturer: manufacturer,
            brand: brand,
            title: "Approved Used " + manufacturer + " Cars for Sale | 6 Month Warranty",
            skipMediahawk: true,
            desc: "Browse approved used " + manufacturer + " cars for sale near you. Our used cars come with a 6-month manufacturer's warranty, full inspection, and ownership history check.",
            customerType: 'Used',
        };
    }

    if (routeName == 'branded-new-cars-in-stock') {
        const brand = route.params.brand || 'randd';
        const manufacturer = getManufacturerFromBrand(brand);
        let title = 'New Cars for Sale | Review & Buy Brand New Car Models in Our 2026 Range';
        let desc = 'Explore the latest new cars for sale at Stellantis &You UK and discover a wide array of models in our 2026 range - Discuss finance and book a test drive';
        if (brand == 'peugeot') {
            title = 'New Peugeot Cars for Sale | Review & Buy Brand New Car Models in Our 2026 Range';
            desc = 'Explore the latest new Peugeot cars for sale at Stellantis &You UK and discover a wide array of models in our 2026 range - Discuss finance and book a test drive';
        } else if (brand == 'ds') {
            title = 'New DS Cars UK | DS Automobiles Dealership, 2026 Range Car Dealers';
            desc = 'Explore the latest new DS Automobiles cars for sale at Stellantis &You UK and discover a wide array of models in our 2026 range - Discuss finance and book a test drive';
        } else if (brand == 'citroen') {
            title = 'New Citroen Cars for Sale UK | 2026 Car Range Prices & Buy Models on Finance';
            desc = 'Explore the latest new Citroen cars for sale at Stellantis &You UK and discover a wide array of models in our 2026 range - Discuss finance and book a test drive';
        } else if (brand == 'vauxhall') {
            title = 'New Vauxhall Cars UK | 2026 Prices & Finance on the Latest Models, Configure & Buy a Brand New Car';
            desc = 'Explore the latest new Vauxhall cars for sale at Stellantis &You UK and discover a wide array of models in our 2026 range - Discuss finance and book a test drive';
        } else {
            title = `New ${manufacturer} Cars UK | 2026 Prices & Finance on the Latest Models, Configure & Buy a Brand New Car`;
            desc = `Explore the latest new ${manufacturer} cars for sale at Stellantis &You UK and discover a wide array of models in our 2026 range - Discuss finance and book a test drive`;
        }
        return {
            bodyClasses: [
                'used',
                'landing',
                'bg-' + brand,
                'stock-search-landing',
                'stock-search-landing--branded',
            ],
            manufacturer: manufacturer,
            brand: brand,
            searchPage: true,
            title: title,
            skipMediahawk: true,
            showMultiBrandLiveChat: true,
            desc: desc,
            newStockSearch: true,
            customerType: 'New',
        }
    }

    return route.meta;
}